export const messages = {
  editor: {
    label: {
      id: 'admin/promotions.form.regular.editor.benefit.price-table.label',
    },
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.price-table.help-text',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.price-table.title',
    },
  },
  validation: {
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
